import * as React from 'react';
import Grid from "@mui/material/Grid";
import PageHeader from '../layout/PageHeader';
import SectionCard from '../layout/SectionCard';
import MetricChart from './MetricChart';
import StatsContainer from './StatsContainer';
import moment from 'moment';
import StatusBreakdownCard from './StatusBreakdownCard';
import TopEntitiesCard from './TopEntitiesCard';
import AggregateStatsTable from './AggregateStatsTable';
import PaymethodSuccessDeclineTable from './PaymethodSuccessDeclineTable';
import useRootHook from '../../hooks/useRoot';
import helpers from '../../helpers/common';

export default function StatsIndex() {
    const {userData} = useRootHook();
    const isMerchant = userData?.role === helpers.roles.M;
    
    const [filters, setFilters] = React.useState({
        from: moment.utc().startOf('day').toISOString(),
        to: moment.utc().endOf('day').toISOString(),
    })

    return <React.Fragment>
        <Grid size={12}>
            <PageHeader title="Stats" breadcrumbs={[['Dashboard', '/'], ['Stats', '/stats']]} />
        </Grid>

        <Grid size={12}>
            <StatsContainer fullPage={true} filters={filters} setFilters={setFilters}>
                <Grid container spacing={{ xs: 2, md: 3 }}>
                    <Grid size={{ xs: 12, xl: 4 }}>
                        <SectionCard sx={{ display: 'flex', flexDirection: 'column', height: 320 }}>
                            <MetricChart title="Gross volume" type="grossAmount" filters={filters} setFilters={setFilters} />
                        </SectionCard>
                    </Grid>
                    <Grid size={{ xs: 12, xl: 4 }}>
                        <SectionCard sx={{ display: 'flex', flexDirection: 'column', height: 320 }}>
                            <MetricChart title="Payments count" type="grossCount" filters={filters} setFilters={setFilters} />
                        </SectionCard>
                    </Grid>
                    <Grid size={{ xs: 12, xl: 4 }}>
                        <SectionCard sx={{ display: 'flex', flexDirection: 'column', height: 320 }}>
                            <MetricChart title="Completed volume" type="totalAmount" filters={filters} setFilters={setFilters} />
                        </SectionCard>
                    </Grid>
                    <Grid size={{ xs: 12, xl: 4 }}>
                        <SectionCard sx={{ display: 'flex', flexDirection: 'column', height: 320 }}>
                            <MetricChart title="Refunds volume" type="refundedAmount" filters={filters} setFilters={setFilters} />
                        </SectionCard>
                    </Grid>
                    <Grid size={{ xs: 12, xl: 4 }}>
                        <SectionCard sx={{ display: 'flex', flexDirection: 'column', height: 320 }}>
                            <MetricChart title="Disputes volume" type="disputedAmount" filters={filters} setFilters={setFilters} />
                        </SectionCard>
                    </Grid>
                    <Grid size={{ xs: 12, xl: 4 }}>
                        <SectionCard sx={{ display: 'flex', flexDirection: 'column', height: 320 }}>
                            <MetricChart title="Declined payments" type="declinedCount" filters={filters} setFilters={setFilters} />
                        </SectionCard>
                    </Grid>

                    <Grid size={{ xs: 12, xl: 6 }}>
                        <SectionCard>
                            <StatusBreakdownCard filters={filters} />
                        </SectionCard>
                    </Grid>
                    {!isMerchant && (
                        <Grid size={{ xs: 12, xl: 6 }}>
                            <SectionCard>
                                <TopEntitiesCard title="Top merchants" type="topMerchants" filters={filters} />
                            </SectionCard>
                        </Grid>
                    )}
                    <Grid size={{ xs: 12, xl: 6 }}>
                        <SectionCard>
                            <TopEntitiesCard title="Top projects" type="topProjects" filters={filters} />
                        </SectionCard>
                    </Grid>
                    <Grid size={{ xs: 12, xl: 6 }}>
                        <SectionCard>
                            <TopEntitiesCard title="Top customers" type="topCustomers" filters={filters} />
                        </SectionCard>
                    </Grid>

                    <Grid size={{ xs: 12, xl: 6 }}>
                        <SectionCard sx={{ overflowX: 'auto' }}>
                            <AggregateStatsTable
                                title="Sum of payments by project"
                                type="projectPaymentSum"
                                dimension="project"
                                metric="sum"
                                filters={filters}
                            />
                        </SectionCard>
        </Grid>
                    {!isMerchant && (
                        <>
                            <Grid size={{ xs: 12, xl: 6 }}>
                                <SectionCard sx={{ overflowX: 'auto' }}>
                                    <AggregateStatsTable
                                        title="Sum of payments by payment method"
                                        type="paymethodPaymentSum"
                                        dimension="paymethod"
                                        metric="sum"
                                        filters={filters}
                                    />
                                </SectionCard>
                            </Grid>
                            <Grid size={{ xs: 12 }}>
                                <SectionCard sx={{ overflowX: 'auto', p: 2 }}>
                                    <PaymethodSuccessDeclineTable filters={filters} />
                                </SectionCard>
                            </Grid>
                        </>
                    )}
                    <Grid size={{ xs: 12, xl: 6 }}>
                        <SectionCard sx={{ overflowX: 'auto' }}>
                            <AggregateStatsTable
                                title="Successful vs declined by project"
                                type="projectSuccessDecline"
                                dimension="project"
                                metric="status"
                                filters={filters}
                            />
                        </SectionCard>
        </Grid>
        </Grid>
            </StatsContainer>
        </Grid>
    </React.Fragment>
}